import { useMemo, useState, useCallback } from "react";

export const useSelectedPlan = (plans = [], selectedPlanId = null) => {
  const [savedPlanId, setSavedPlanId] = useState(null);

  const selectedPlan = useMemo(() => {
    if (!plans?.length) return null;

    if (savedPlanId) {
      const savedPlan = plans.find(plan => plan.id === savedPlanId);
      if (savedPlan) return savedPlan;
    }

    if (selectedPlanId) {
      const planFromProps = plans.find(plan => plan.id === selectedPlanId);
      if (planFromProps) return planFromProps;
    }

    return plans.find(plan => plan.isDefault) || plans[0];
  }, [plans, selectedPlanId, savedPlanId]);

  const saveSelectedPlan = useCallback((planId) => {
    setSavedPlanId(planId);
  }, []);

  const clearSavedPlan = useCallback(() => {
    setSavedPlanId(null);
  }, []);

  return {
    selectedPlan,
    saveSelectedPlan,
    clearSavedPlan,
    savedPlanId
  };
};
